import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";
import { NewButton, SaveButton } from "../../../../components/Buttons";

export const Group = () => {
    document.title = "Qrup";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Məhsullar", value: "/products" },
        { name: "Parametrlər", value: "/products/parameters" },
        { name: "Qrup", value: "/products/parameters/group", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Qrup</h2>
                    <p>
                        <NewButton>Yeni qrup</NewButton> düyməsi ilə məhsulları qruplaşdırmaq üçün qruplar təyin olunur. Qrup formalaşdırıb məhsulları qruplara
                        ayırmaq, gələcəkdə hesabatlar əldə etmək, məhsulu axtarmaq və filterləmək zamanı istifadə olunur. Bunun üçün qrup adını təyin edib
                        <SaveButton /> düyməsini sıxmaq lazımdır.
                    </p>
                    <img src="/images/products/parameters/service.gif" alt="Qrup" />
                </article>
            </div>
        </div>
    );
};
